import { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
// import OtpInput from "react-otp-input";
import { Layout, Modal } from "components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight, faRecycle } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { resendOTP, verifyOTP, existedAppointmentBooking } from "services/api-service";
import { useSelector, batch, useDispatch } from "react-redux";
import { updateAppointmentInfo } from "redux/appointment";
import { updateAppointmentBookingInfo } from "redux/appointmentBooking";
import { changeOtpAppointmentExistence } from "redux/services";
import _ from "lodash";

import { SERVICE_CHANNEL, ACTION_CONFIRMATION, APPOINTMENT_EXISTENCE } from "constants/route";

const SUCCESS = "SUCCESS";
const INVALID_OTP = "Invalid OTP";

const OTP_TIMEOUT = 30;

export default function OtpForm() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { nric, mobile } = useSelector((state) => state.appointment);
  const { previousRouteName } = useSelector((state) => state.appointmentBooking);
  const [otp, setOtp] = useState("");
  const [otpTime, setOtpTime] = useState(OTP_TIMEOUT);
  const [isSent, setIsSent] = useState(false);
  const [error, setError] = useState();

  const [isOpenModal, setIsOpenModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    resendOTP(nric, mobile.toString());
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (otpTime > 0) setOtpTime(otpTime - 1);
    }, 1000);
    return () => clearTimeout(timer);
  }, [otpTime]);

  const handleOnChangeOpt = (v) => {
    setOtp(v);
  };

  const handleVerifyOTP = async () => {
    const response = await verifyOTP(nric, mobile.toString(), otp);
    const data = response.data;

    if (!data?.validation) {
      setError(data.message || INVALID_OTP);
      return;
    }

    const res = await existedAppointmentBooking(nric);
    if (_.isEmpty(res.data) && previousRouteName == ACTION_CONFIRMATION) {
      setErrorMessage(res.data);
      setIsOpenModal(true);
      return;
    }
    if (!_.isEmpty(res.data)) {
      const data = res.data;
      batch(() => {
        dispatch(updateAppointmentInfo(data));
        dispatch(updateAppointmentBookingInfo(data));
      });

      navigate(APPOINTMENT_EXISTENCE, {
        replace: true
      });
      dispatch(
        changeOtpAppointmentExistence({
          mainId: data.service_id,
          subServiceId: data.sub_service_id,
          mainWebDisplayText: data.scheme
        })
      );
      return;
    }

    previousRouteName != ACTION_CONFIRMATION &&
      navigate(SERVICE_CHANNEL, {
        replace: true
      });
  };

  const resend = () => {
    resendOTP(nric, mobile).then(({ data }) => {
      if (data.status === SUCCESS) {
        setIsSent(true);
      } else {
        setError(data.message);
      }
    });
    setOtpTime(OTP_TIMEOUT);
    setError();
    setOtp("");
  };

  const goPrevious = () => {
    setErrorMessage("");
    setIsOpenModal(false);
    navigate(-1);
  };

  const footer = (
    <Button variant="danger" onClick={goPrevious}>
      OK
    </Button>
  );

  return (
    <Layout>
      <div className="center">
        <Form>
          <div className="otpContainer">
            <div className="bg-wrapper col-md-9 col-lg-6 mx-auto">
              <Form.Group className="form-padding alignLeft">
                <Form.Label>
                  <h6>Enter OTP code has been sent to your number:</h6>
                </Form.Label>
              </Form.Group>
              <div className="container">
                <div className="row">
                  <Form.Group className="col col-xs-2 opt-input">
                    {/* <OtpInput
                      containerStyle={{ justifyContent: "center" }}
                      value={otp}
                      numInputs={6}
                      onChange={handleOnChangeOpt}
                      separator={<span>-</span>}
                      inputStyle={{
                        color: "#ff3333",
                        fontSize: "20px",
                        height: "40px",
                        width: "40px",
                        borderRadius: "10px",
                        border: "none",
                        outline: "none"
                      }}
                    /> */}
                  </Form.Group>
                </div>
              </div>
            </div>
            <div className="mt-4 mx-auto">
              <Button
                className="btn-cstm btn-cstmGreen"
                type="button"
                disabled={otp.length !== 6}
                onClick={handleVerifyOTP}>
                Verify
                <FontAwesomeIcon icon={faAngleRight} className="btnIconR" color="white" />
              </Button>
              <Button
                className={`btn-cstm ${otpTime > 0 ? "btn-light" : "btn-default"}`}
                type="button"
                onClick={resend}
                disabled={otpTime != 0}>
                Resend OTP {otpTime > 0 ? otpTime : null}
                <FontAwesomeIcon icon={faRecycle} className="btnIconR" color="white" />
              </Button>
            </div>
          </div>
          {isSent && (
            // <div className="text-success">OTP has sent to your phone.</div>
            <div className="text-success"></div>
          )}
          {error && <div className="text-red">{error}</div>}
        </Form>
      </div>
      <Modal
        isOpen={isOpenModal}
        titleClassName="text-danger"
        title="Not Found"
        body={errorMessage}
        footer={footer}
        closeButton={false}
      />
    </Layout>
  );
}
